import {UPDATE_OPERATOR_DATA} from './constants'
import {IUPDATE_OPERATOR_DATA} from './validations';
 export function updateOperatorData(
    actionData: IUPDATE_OPERATOR_DATA['actionData'],
  ): IUPDATE_OPERATOR_DATA {
    return {
      type: UPDATE_OPERATOR_DATA,
      actionData,
    };
 }
